<ng-container *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">VALUE STREAM</h5>
                <div style="flex-grow: 1;"></div>
                <button id="add" (click)="addNewVs()" class="btn btn-primary float-right mr-3"> Add Value Stream
                </button>
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100"
                           placeholder="Keywords" type="text" ng-reflect-maxlength="100" ng-reflect-model=""
                           [(ngModel)]="vsReg">
                    <div>
                        <button id="Search" (click)="searchPValueStream()" class="btn btn-primary float-left">Search
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3" *ngIf='vsList && vsList.length'>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Description">
                        <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let vs of vsList;">

                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{vs.valueStreamCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{vs.valueStreamCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{vs.name}}">
                    <h6 class="mb-lg-0 text-truncate"> {{vs.name}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{vs.shortDesc}}">
                    <h6 class="mb-lg-0 text-truncate"> {{vs.shortDesc}} </h6>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                        <i class="fa fa-ellipsis-h" [id]="vs.id" (click)=entityOps($event)></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedVSId==vs.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(vs)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li (click)="removeVs(vs)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>

                </div> -->
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" [id]="vs.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                        <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedVSId==vs.id?true:false">
                            <i class="fa fa-caret-up caret-up mr-2"></i>
                            <ul class="m-0 p-0">
                                <li (click)="clickEdit(vs)">
                                    <i class="fa fa-pencil mr-2"></i>Edit
                                </li>
                                <li (click)="removeUom(vs)">
                                    <i class="fa fa-trash mr-2"></i>Delete
                                </li>
                            </ul>
                        </div>
                    </h6>
                </div>
            </div>
            <ng-container *ngIf='vsList.length == 0'>
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>
            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalvs}} items
                </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='vsList && vsList.length' [collectionSize]="totalvs" [rotate]="true" [maxSize]="5"
                                [pageSize]="pageSize" [ellipses]="false" [boundaryLinks]="true" [(page)]="currentPage"
                                (pageChange)="onPageChange($event)"
                                class="float-right"></ngb-pagination>
            </div>
        </div>
        <!-- ADDING OR UPDATING VALUE STREAM-->
        <div class="w-100 float-left" *ngIf='vsPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Value Stream </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Value Stream - {{vsData.valueStreamCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>

            </div>
            <div class="w-100 float-left mt-3">
                <div class='col-lg-6 col-md-6 left-clear'>
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="vsData.name" name="name"
                               placeholder=" Value Stream Name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 left-clear'>
                    <div class="form-group">
                        <label> Short Description
                            <span class="text-danger medium"></span>
                        </label>
                        <textarea maxlength="200" class="form-control" rows="3" [(ngModel)]="vsData.shortDesc"
                                  name="shortDescription"
                                  placeholder="Short Description (Optional)"></textarea>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 left-clear'>
                    <div class="form-group">
                        <label> Long Description
                            <span class="text-danger medium"></span>
                        </label>
                        <textarea maxlength="350" class="form-control" rows="3" [(ngModel)]="vsData.longDesc"
                                  name="longDescription"
                                  placeholder="Long Description (Optional)"></textarea>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="onSave()">Save</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 float-left min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/valueStream.component.html